(() => {
  const normalize = v => String(v || '').trim().toLowerCase();
  function init(root = document) {
    root.querySelectorAll('[data-xc-recommended]:not([data-pill-ready])').forEach(section => {
      section.dataset.pillReady = 'true';
      const track = section.querySelector('.xc-pill-tabs');
      const tabs = [...track.querySelectorAll('[data-xc-tab]')];
      const limit = Number(section.dataset.xcLimit) || 10;
      const inFlight = new Map();
      const panelFor = tab => section.querySelector('#' + CSS.escape(tab.dataset.xcTab));
      const status = (panel, text, retry = false) => {
        const label = panel.querySelector('[data-xc-tab-status]'); label.textContent = text; label.hidden = !text;
        panel.querySelector('[data-xc-tab-retry]').hidden = !retry;
      };
      const sourceFor = tab => {
        const url = new URL(tab.dataset.xcTabSource, location.origin);
        if (url.origin !== location.origin) throw new Error('Invalid collection');
        const preview = new URLSearchParams(location.search).get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        return url;
      };
      async function load(tab) {
        const panel = panelFor(tab);
        if (!panel || panel.dataset.xcTabLoaded === 'true' || inFlight.has(tab)) return;
        const controller = new AbortController(); inFlight.set(tab, controller);
        const timeout = setTimeout(() => controller.abort(), 15000);
        panel.setAttribute('aria-busy','true'); status(panel,'Loading products…');
        try {
          const url = sourceFor(tab); url.searchParams.set('section_id','xc-tab-results');
          const response = await fetch(url, {signal:controller.signal,headers:{'X-Requested-With':'XMLHttpRequest'}});
          if (!response.ok) throw new Error('Unable to load products');
          const doc = new DOMParser().parseFromString(await response.text(),'text/html');
          const results = doc.querySelector('[data-xc-tab-results]');
          if (!results) throw new Error('Missing product results');
          const brand = '|' + normalize(tab.dataset.xcTabBrand) + '|';
          const mode = tab.dataset.xcTabMode;
          const items = [...results.querySelectorAll('.xc-tab-result-item')].filter(item => mode === 'all' || (mode === 'brand' ? item.dataset.xcResultBrand?.includes(brand) : item.dataset.xcResultCategory?.includes('|' + mode + '|'))).slice(0,limit);
          const grid = panel.querySelector('[data-xc-tab-grid]'); grid.replaceChildren();
          items.forEach((item,index) => {
            const oldModal = item.querySelector('quick-add-modal');
            if (oldModal) {
              const oldId = oldModal.id, id = 'XCQuickShop-' + panel.id + '-' + index;
              item.querySelectorAll('[id],[data-modal]').forEach(el => {
                if (el.id) el.id = el.id.replace(oldId,id);
                if (el.hasAttribute('data-modal')) el.dataset.modal = '#' + id;
              });
            }
            grid.append(item);
          });
          panel.dataset.xcTabLoaded = 'true';
          status(panel, items.length ? '' : 'No matching products in this selection. Open View All to browse the full category or brand.');
        } catch (_) { status(panel,'Products could not load. Try again or open View All.',true); }
        finally { clearTimeout(timeout); inFlight.delete(tab); panel.removeAttribute('aria-busy'); }
      }
      function activate(tab, focus = false) {
        tabs.forEach(item => { const active = item === tab; item.setAttribute('aria-selected',String(active)); item.tabIndex = active ? 0 : -1; panelFor(item).hidden = !active; });
        const selectedLink = section.querySelector('[data-xc-selected-shop]');
        selectedLink.href = sourceFor(tab).href;
        if (focus) tab.focus({preventScroll:true});
        const r = tab.getBoundingClientRect(), box = track.getBoundingClientRect();
        if (r.left < box.left) track.scrollBy({left:r.left-box.left-8,behavior:'smooth'});
        else if (r.right > box.right) track.scrollBy({left:r.right-box.right+8,behavior:'smooth'});
        load(tab);
      }
      tabs.forEach((tab,index) => {
        tab.addEventListener('click',()=>activate(tab));
        tab.addEventListener('keydown',e => {
          if (!['ArrowLeft','ArrowRight','Home','End'].includes(e.key)) return;
          e.preventDefault();const next=e.key==='Home'?0:e.key==='End'?tabs.length-1:(index+(e.key==='ArrowRight'?1:-1)+tabs.length)%tabs.length;activate(tabs[next],true);
        });
        panelFor(tab).querySelector('[data-xc-tab-retry]').addEventListener('click',()=>load(tab));
      });
      const updateArrows = () => {
        section.querySelector('[data-xc-pill-prev]').disabled = track.scrollLeft <= 2;
        section.querySelector('[data-xc-pill-next]').disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      };
      section.querySelector('[data-xc-pill-prev]').addEventListener('click',()=>track.scrollBy({left:-track.clientWidth*.7,behavior:'smooth'}));
      section.querySelector('[data-xc-pill-next]').addEventListener('click',()=>track.scrollBy({left:track.clientWidth*.7,behavior:'smooth'}));
      track.addEventListener('scroll',updateArrows,{passive:true});
      const resize = new ResizeObserver(updateArrows);resize.observe(track);updateArrows();
      if (tabs[0]) activate(tabs[0]);
      section.addEventListener('xc-tabs-cleanup',()=>{resize.disconnect();inFlight.forEach(controller=>controller.abort());});
    });
  }
  init();document.addEventListener('shopify:section:load',event=>init(event.target));
  document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-xc-recommended]').forEach(section=>section.dispatchEvent(new Event('xc-tabs-cleanup'))));
})();
